(function () {
    'use strict';

    angular
        .module('sod.helper')
        .directive('tilesEditable', tilesEditable);

    function tilesEditable(lodash) {
        return {
            restrict: 'E',
            controller: tilesEditableCtrl,
            controllerAs: 'vm',
            bindToController: true,
            require: 'ngModel',
            scope: {
                options: '=',
                showList: '=?'
            },
            link: function (scope, elem, attrs, ctrl) {
                var vm = scope.vm;
                vm.ngModelCtrl = ctrl;

                ctrl.$formatters.push(function (modelValue) {
                    if (!modelValue) {
                        modelValue = [];
                    }
                    return modelValue;
                });

                ctrl.$render = function () {
                    vm.model = ctrl.$viewValue;
                };

                // if (lodash.has(vm.options, 'events.change')) {
                //     scope.$watch(function() {
                //         return lodash.differenceWith(vm.model)
                //     })
                // }
            },
            templateUrl: function (elem, attrs) {
                return 'common/components/tiles-editable/tiles-editable';
            }
        };
    }

    function tilesEditableCtrl($element, lodash, $timeout, $scope, $q, GenericModel, ActionManager) {
        var vm = this;

        this.$onInit = function() {
            vm.actions = {
                list: [
                    {label: lodash.get(vm.options, 'labels.actions.add', 'Add'), callbackName: 'onAdd', name: 'add'},
                    {label: lodash.get(vm.options, 'labels.actions.sort', 'Sort'), callbackName: 'onSort', name: 'sort'}
                ],
                add: [
                    {
                        label: lodash.get(vm.options, 'labels.actions.apply', 'Apply'),
                        callbackName: 'onItemApply',
                        name: 'apply'
                    },
                    {
                        label: lodash.get(vm.options, 'labels.actions.cancel', 'Cancel'),
                        callbackName: 'onItemCancel',
                        name: 'cancel'
                    }
                ],
                edit: [
                    {
                        label: lodash.get(vm.options, 'labels.actions.apply', 'Apply'),
                        callbackName: 'onItemApply',
                        name: 'apply'
                    },
                    {
                        label: lodash.get(vm.options, 'labels.actions.cancel', 'Cancel'),
                        callbackName: 'onItemCancel',
                        name: 'cancel'
                    },

                    {
                        label: lodash.get(vm.options, 'labels.actions.remove', 'Remove'),
                        callbackName: 'onItemRemove',
                        name: 'remove',
                        'class': 'float-right'
                    },
                ],
                sort: [
                    {
                        label: lodash.get(vm.options, 'labels.actions.done_sorting', 'Done Sorting'),
                        callbackName: 'onSortCancel',
                        name: 'cancel'
                    }
                ],
            };
            vm.newModel = null;

            vm.selectedIndex = null;
            vm.sortable = false;
            vm.selectedActionType = 'list';


            const hide_on_active_dom = lodash.get(vm.options, 'detailOptions.hide_on_active', null);
            // hide and unhide save button
            if (hide_on_active_dom) {
                $scope.$watch(function () {
                    return vm.selectedActionType;
                }, function (newValue, oldValue) {
                    if (newValue === 'list') {
                        $(hide_on_active_dom).show();
                    } else {
                        $(hide_on_active_dom).hide();
                    }
                });
            }

            vm.sortableOptions = {
                container: $element.find('.tiles-list-wrapper'),
                start: function (e) {
                    console.log('start dragging');
                },
                end: function (e) {
                    console.log('end dragging');
                },
                handler: '.sortable-handle, .sortable-handle *',
                hint: function (elem) {
                    return elem
                        .clone().addClass(
                            lodash.concat(
                                ['sortable-hint', 'question-item-dragging'],
                                lodash.get(vm, 'options.sortable_options.hint_css_array', [])
                            ).join(' ')
                        );
                    // var hasHintTemplate = lodash.has(vm, 'options.sortable_options.hint_template');
                    // if(hasHintTemplate) {
                    //     var hintTemplate = lodash.has(vm, 'options.sortable_options.hint_template', '');
                    //     return elem.clone().html(hintTemplate);
                    // } else {
                    //     return elem.clone().addClass('sortable-hint');
                    // }
                },
                placeholder: function (elem) {
                    var placeholderElem = elem.clone();
                    var placeholderTemplate = lodash.get(vm.options, 'sortable_options.placeholder_template', '<div class="sortable-placeholder-drop-here">Drop here</div>');
                    placeholderElem.find('.tile-item').html(placeholderTemplate);
                    placeholderElem.addClass('sortable-placeholder');
                    return placeholderElem;
                },
                disabled: '.sort-disabled',
                change: function (e) {
                    if (e) {
                        var itemMoved = vm.model[e.oldIndex];
                        vm.model.splice(e.oldIndex, 1);
                        vm.model.splice(e.newIndex, 0, itemMoved);
                        $scope.$apply();
                    }
                    reorderRowIndex();
                },
            };

            vm.edit = edit;
            vm.onItemApply = onItemApply;
            vm.onItemCancel = onItemCancel;
            vm.onAdd = onAdd;
            vm.onSort = onSort;
            vm.onSortCancel = onSortCancel;
            vm.applyCallback = applyCallback;
            vm.onItemRemove = onItemRemove;
            vm.isActionAvailable = isActionAvailable;
            vm.getMode = getMode;

            vm.showList = showList;
        }

        function applyCallback(action) {
            if (typeof vm[action.callbackName] === typeof function () {
                }) {
                vm[action.callbackName]();
            }
        }

        function onAdd() {
            vm.newModel = {edit_model: {}};
            vm.selectedActionType = 'add';
        }

        function onSort() {
            vm.selectedActionType = 'sort';
            vm.sortable = true;
        }

        function onSortCancel() {
            vm.selectedActionType = 'list';
            vm.sortable = false;
        }

        function edit(item) {
            var index = lodash.findIndex(vm.model, function (_i) {
                return item.$$hashKey === _i.$$hashKey
            });
            toggleEdit(index);
        }

        function onItemApply() {
            // validate first
            var targetForm = lodash.get(vm.options, 'validationOptions.targetForm', null);
            !!targetForm && ActionManager('form-clear-validation', {formId: targetForm});
            $q.when(validate(), function (res) {
                console.log('$q.when after');
                if (typeof vm.applyItemChange === typeof function () {
                    }) {
                    vm.applyItemChange();
                }
                if (vm.selectedActionType === 'add') {
                    vm.model.push(vm.newModel);
                }
                toggleEdit(null);
            }, function (res) {
                !!targetForm && ActionManager('form-validation', {formId: targetForm}, {}, {response: res.data});
                console.log('$q.when error');
            });

        }

        function onItemCancel() {
            if (typeof vm.cancelItemChange === typeof function () {
                }) {
                vm.cancelItemChange();
            }
            toggleEdit(null);
        }

        function onItemRemove() {
            vm.model.splice(vm.selectedIndex, 1);
            toggleEdit(null);
        }

        function toggleEdit(index) {
            if (index !== null && index > -1) {
                vm.selectedIndex = index;
                vm.selectedActionType = 'edit';
            } else {
                vm.selectedIndex = null;
                vm.selectedActionType = 'list';
                vm.newModel = null;
            }
        }

        function reorderRowIndex() {
            // if (hasSortableOption()) {
            $timeout(function () {
                angular.forEach(vm.model, function (row, index) {
                    row.edit_model.order = index;
                });
            });
            // }
        }

        function isActionAvailable(action) {
            if (!lodash.has(vm.options, 'disabled_options')) {
                return true;
            }

            return !(lodash.indexOf(vm.options.disabled_options, action.name) > -1);
        }

        function validate() {
            if (lodash.has(vm.options, 'validationOptions.datasource')) {
                var data = {
                    data: (vm.selectedActionType === 'add') ? vm.newModel : vm.model[vm.selectedIndex],
                };

                var model = new GenericModel(vm.options.validationOptions.datasource.url);
                var method = lodash.get(vm.options.validationOptions.datasource, 'method', 'get');

                return model[method]({}, data).$promise;
            }
            return $timeout(function () {
                return true;
            });
        }

        function getMode() {
            return vm.selectedActionType + '-mode';
        }

        function showList() {
            onItemCancel();
            onSortCancel();
        }


    }
})();